import React from 'react';
//import SelectClient from './selectclient';
//import { Button  } from 'react-bootstrap';


class BookmarkTitle extends React.Component{
    constructor(props)
    {
        super(props);
        
        this.onNextButtonClick = this.onNextButtonClick.bind(this);
    }

    onSelectClient(selectedClient){
        if(selectedClient && selectedClient.Id && selectedClient.Id > 0){
            if(this.props.onClientSelectionForBookmark)
            {
                this.props.onClientSelectionForBookmark(selectedClient);
            }
        }
    }

    onNextButtonClick()
    {
        const { selectedClient } = this.props;
        if(selectedClient && selectedClient.Id && selectedClient.Id > 0){
            if(this.props.onClientSelectionForBookmark)
            {
                this.props.onClientSelectionForBookmark(selectedClient);
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        
    }

    render()
    {
        const { selectedClient } = this.props;

        //let self = this;
        //var onSelectClient = self.onSelectClient.bind(self);

        // var selectClientPopover = (
        //     <Popover id="popover-select-client" style={{zIndex: "9999"}}>
        //         <div className="form-group" style={{minWidth: "200px"}}>
        //             <SelectClient
        //                 onSelectClient={onSelectClient}
        //                 willSaveClient={true} />
        //         </div>
        //     </Popover>
        // );

        return(
            <div ref="searchTitleBar" className="col-sm-12 sort-by js-sort-by bookmark-title">                
                {(!selectedClient || selectedClient === undefined || selectedClient === null) &&
                    <div className="fluid row">
                        Please select Client to bookmark properties.
                    </div>
                }
                {(selectedClient) &&
                    <div className="fluid row">
                        You've selected <b>{this.props.bookmarkedItems.length}</b> properties.<br/>                
                        Bookmark and email this property to 
                        <span>
                            <span className="tru-bold mg-lt-5">{selectedClient.FirstName + " " + selectedClient.LastName}</span>
                            <button className="tru-btn tru-btn-theme mg-top-10 mg-lt-10" value="NEXT" onClick={this.onNextButtonClick} >NEXT</button>                           
                        </span> 
                    </div>
                }
        
                </div>
        )
    }
}

export default BookmarkTitle;